const fa = {
  pleaseEnterUsername: "لطفاً نام کاربری را وارد کنید",
  cannotFriendYourself: "نمی‌توانید برای خودتان درخواست دوستی ارسال کنید.",
  friendRequestSent: "درخواست دوستی ارسال شد!",
  failedToSendRequest: "ارسال درخواست ناموفق بود",
  linkCopied: "پیوند در کلیپ‌بورد کپی شد!",
  backToInvites: "بازگشت به دعوت‌ها",
  sendFriendRequestByUsername: "ارسال درخواست دوستی با نام کاربری",
  enterUsername: "نام کاربری را وارد کنید",
  send: "ارسال",
  yourInviteQrCode: "کد QR دعوت شما",
  inviteLink: "پیوند دعوت",
  scanQrOrUseLink: "این کد QR را اسکن کنید یا از این پیوند برای ارسال درخواست دوستی استفاده کنید",
  copyInviteLink: "کپی پیوند دعوت",
  goToItem: "رفتن به مورد",
  verificationEmailSent: "ایمیل تأیید ارسال شد! صندوق ورودی خود را بررسی کنید.",
  verificationEmailFailed: "ارسال ایمیل تأیید ناموفق بود. لطفاً دوباره تلاش کنید.",
  verifyYourEmail: "ایمیل خود را تأیید کنید",
  verifyEmailInstructions: "برای دسترسی به حساب خود، لطفاً آدرس ایمیل خود را تأیید کنید. برای یافتن پیوند تأیید، صندوق ورودی خود را بررسی کنید.",
  sending: "در حال ارسال...",
  resendVerificationEmail: "ارسال مجدد ایمیل تأیید",
  login: "ورود",
  register: "ثبت‌نام",
  home: "خانه",
  calendar: "تقویم",
  friends: "دوستان",
  profile: "پروفایل",
  logout: "خروج",
  loading: "در حال بارگذاری...",
  language: "زبان",
  calendarSelectPlaceSuggestion: "لطفاً مکانی را از پیشنهادها انتخاب کنید تا مختصات آن ضمیمه شود.",
  calendarSelectDateAndTime: "لطفاً تاریخ و زمان را انتخاب کنید.",
  calendarPositiveDuration: "لطفاً یک مدت زمان مثبت وارد کنید.",
  calendarFutureDateRequired: "تاریخ و زمان رویداد باید در آینده باشد.",
  calendarCreateEventFailed: "ایجاد رویداد ناموفق بود. لطفاً دوباره تلاش کنید.",
  cancel: "لغو",
  createNewEvent: "ایجاد رویداد جدید",
  week: "هفته",
  month: "ماه",
  eventTitle: "عنوان",
  date: "تاریخ",
  time: "زمان",
  duration: "مدت",
  endsAt: "پایان در",
  place: "مکان",
  searchForPlace: "جستجوی مکان",
  placeSearchTip: "نکته: شروع به تایپ کنید و یک نتیجه را برای ضمیمه کردن مختصات انتخاب کنید.",
  description: "توضیحات",
  createEvent: "ایجاد رویداد",
  today: "امروز",
  previousMonth: "ماه قبل",
  nextMonth: "ماه بعد",
  previous: "قبلی",
  next: "بعدی",
  mondayShort: "دوش",
  tuesdayShort: "سه‌",
  wednesdayShort: "چهار",
  thursdayShort: "پنج",
  fridayShort: "جمع",
  saturdayShort: "شنبه",
  sundayShort: "یکش",
  more: "بیشتر",
  mustRespondWillBeforeReposting: "پیش از بازنشر باید «شرکت خواهم کرد» را انتخاب کنید",
  event: "رویداد",
  backToCalendar: "بازگشت به تقویم",
  addToGoogleCalendar: "افزودن به تقویم گوگل",
  when: "چه زمانی",
  where: "کجا",
  openLocationInGoogleMaps: "باز کردن موقعیت در Google Maps",
  hosts: "میزبانان",
  yourResponse: "پاسخ شما",
  currentResponse: "پاسخ فعلی",
  response_will: "شرکت خواهم کرد",
  response_might: "شاید شرکت کنم",
  response_wont: "شرکت نخواهم کرد",
  willRunIntoYou: "سری می‌زنم",
  mightDropBy: "شاید سری بزنم",
  wontCome: "نمی‌آیم",
  repostToMyFriends: "بازنشر برای دوستانم",
  responses: "پاسخ‌ها",
  willAttend: "شرکت خواهد کرد",
  reposted: "بازنشر شد",
  mightAttend: "شاید شرکت کند",
  cancelEvent: "لغو رویداد",
  cancellationEmailNoticeBefore: "افرادی که اعلام کرده‌اند شرکت خواهند کرد",
  cancellationEmailNoticeAfter: "از طریق ایمیل از لغو رویداد مطلع خواهند شد.",
  optionalCancellationMessage: "پیام اختیاری برای شرکت‌کنندگان (حداکثر ۱۰۰۰ کاراکتر)",
  confirmCancelEvent: "تأیید لغو رویداد",
  clear: "پاک کردن",
  confirmCancellation: "تأیید لغو",
  confirmCancellationMessage: "آیا مطمئن هستید که می‌خواهید این رویداد را لغو کنید؟ این کار به شرکت‌کنندگان تأییدشده اطلاع می‌دهد و رویداد را حذف می‌کند.",
  eventCancelledNotified: "رویداد لغو شد. اطلاع‌رسانی شد به",
  attendees: "شرکت‌کننده",
  failedToCancelEvent: "لغو رویداد ناموفق بود",
  back: "بازگشت",
  cancelled: "لغوشده",
  ok: "تأیید",
  forgotPassword: "رمز عبور را فراموش کرده‌ام",
  email: "ایمیل",
  passwordResetLinkSent: "اگر حسابی وجود داشته باشد، پیوند بازنشانی ارسال شده است.",
  passwordResetRequestFailed: "درخواست بازنشانی رمز عبور ناموفق بود.",
  sendResetLink: "ارسال پیوند بازنشانی",
  addFriend: "افزودن دوست",
  incomingRequests: "درخواست‌های دریافتی",
  accept: "پذیرفتن",
  deny: "رد کردن",
  myFriends: "دوستان من",
  noFriendsYet: "هنوز دوستی ندارید. شروع به اضافه کردن دوستان کنید!",
  seeProfile: "مشاهده پروفایل",
  noEventsToRespondTo: "هیچ رویدادی برای پاسخ وجود ندارد",
  allCaughtUp: "همه چیز را بررسی کرده‌اید. بعداً برای رویدادهای جدید دوستانتان بازگردید.",
  events: "رویدادها",
  unknown: "نامشخص",
  noDescriptionProvided: "توضیحی ارائه نشده است.",
  will: "بله",
  maybe: "شاید",
  wont: "خیر",
  userNotFound: "کاربر پیدا نشد",
  friendRequestSentSuccessfully: "درخواست دوستی با موفقیت ارسال شد!",
  friendInvitation: "دعوت دوستی",
  sendFriendRequest: "ارسال درخواست دوستی",
  loginToSendFriendRequest: "برای ارسال درخواست دوستی لطفاً وارد شوید",
  chooseLanguage: "انتخاب زبان",
  invalidCredentials: "اطلاعات ورود نامعتبر است. لطفاً دوباره تلاش کنید.",
  username: "نام کاربری",
  password: "رمز عبور",
  forgotPasswordQuestion: "رمز عبور خود را فراموش کرده‌اید؟",
  dontHaveAccount: "حساب کاربری ندارید؟",
  registerHere: "اینجا ثبت‌نام کنید",
  invalidProfilePhotoType: "نوع فایل نامعتبر است. لطفاً یک تصویر JPEG، PNG، GIF یا WebP بارگذاری کنید.",
  invalidFileExtension: "پسوند فایل نامعتبر",
  allowedExtensions: "مجاز",
  fileTooLarge: "فایل بیش از حد بزرگ است",
  maximumFileSize: "حداکثر",
  profilePhotoRemoved: "عکس پروفایل حذف شد.",
  failedToRemoveProfilePhoto: "حذف عکس پروفایل ناموفق بود",
  profileUpdatedSuccessfully: "پروفایل با موفقیت به‌روزرسانی شد!",
  failedToUpdateProfile: "به‌روزرسانی پروفایل ناموفق بود",
  privateEmailExplanation: "فقط شما می‌توانید ایمیل خود را ببینید تا از پیام‌های ناخواسته خارج از پلتفرم جلوگیری شود",
  yourEmailIsPrivate: "ایمیل شما خصوصی است.",
  profilePhoto: "عکس پروفایل",
  removePhoto: "حذف عکس",
  firstName: "نام",
  lastName: "نام خانوادگی",
  tellPeopleAboutYourself: "درباره خودتان به دیگران بگویید",
  whereToContactMe: "راه‌های تماس با من",
  contactInfoPlaceholder: "Instagram: myUsername\nDiscord: myDiscord",
  save: "ذخیره",
  notSet: "تنظیم نشده",
  editProfile: "ویرایش پروفایل",
  imageToCrop: "تصویر برای برش",
  zoom: "بزرگ‌نمایی",
  usePhoto: "استفاده از عکس",
  name: "نام",
  whereToContact: "اطلاعات تماس",
  removeFriendship: "حذف دوستی",
  confirmRemoveFriend: "تأیید حذف دوست",
  confirmRemoveFriendBefore: "آیا مطمئن هستید که می‌خواهید",
  confirmRemoveFriendAfter: "را از فهرست دوستان خود حذف کنید؟",
  friendRemoved: "دوست حذف شد.",
  failedToRemoveFriend: "حذف دوست ناموفق بود.",
  confirmRemove: "تأیید حذف",
  error: "خطا",
  removed: "حذف شد",
  passwordsDoNotMatch: "رمزهای عبور مطابقت ندارند",
  registrationFailed: "ثبت‌نام ناموفق بود. لطفاً دوباره تلاش کنید.",
  confirmPassword: "تأیید رمز عبور",
  alreadyHaveAccount: "قبلاً حساب کاربری دارید؟",
  loginHere: "اینجا وارد شوید",
  passwordResetSuccessfully: "رمز عبور با موفقیت بازنشانی شد.",
  failedToResetPassword: "بازنشانی رمز عبور ناموفق بود.",
  resetPassword: "بازنشانی رمز عبور",
  newPassword: "رمز عبور جدید",
  confirmNewPassword: "تأیید رمز عبور جدید",
  setNewPassword: "تنظیم رمز عبور جدید",
  emailVerifiedSuccessfully: "ایمیل با موفقیت تأیید شد!",
  emailVerificationFailed: "تأیید ناموفق بود. ممکن است پیوند نامعتبر یا منقضی شده باشد.",
  verifying: "در حال تأیید...",
  verified: "تأیید شد!",
  redirectingToHome: "در حال انتقال به صفحه اصلی...",
  verificationFailed: "تأیید ناموفق بود",
  goToHome: "رفتن به صفحه اصلی",
  about: "درباره",
  aboutConceptTitle: "ایده",
  aboutCreatorIntroduction: "سلام، من Crypt0 هستم، سنگ‌نورد و سازنده Run Into Me.",
  aboutCreatorStory: "این وب‌سایت را ساختم چون اجتماعی هستم و زمان زیادی را صرف هماهنگ‌کردن برنامه‌ها با سنگ‌نوردان دیگر می‌کردم.",
  aboutPlanningProblem: "می‌خواستم بدون دعوت رسمی، زمان و مکان سنگ‌نوردی را هم‌زمان به همه اطلاع دهم.",
  aboutDeveloperSolution: "بعد به یاد آوردم که توسعه‌دهنده هستم و می‌توانم راه‌حل را خودم بسازم.",
  aboutWelcome: "به Run Into Me خوش آمدید؛ جایی برای اطلاع‌دادن فعالیت‌هایی که دوستانتان می‌توانند بدون فشار به آن‌ها بپیوندند.",
  aboutCallToAction: "فعالیت بعدی را که با دیگران لذت‌بخش‌تر است اینجا منتشر کنید!",
  aboutTutorialTitle: "راهنما",
  aboutCalendarCreateEvent: "در صفحه تقویم می‌توانید رویداد جدیدی نیز ایجاد کنید.",
  aboutEventColorsIntroduction: "رنگ‌ها وضعیت شرکت شما را نشان می‌دهند:",
  aboutColorGold: "طلایی",
  aboutColorGoldDescription: "میزبان این رویداد هستید.",
  aboutColorGreen: "سبز",
  aboutColorGreenDescription: "در این رویداد شرکت می‌کنید.",
  aboutColorOrange: "نارنجی",
  aboutColorOrangeDescription: "پاسخ «شاید» داده‌اید.",
  aboutColorBlue: "آبی",
  aboutColorBlueDescription: "هنوز پاسخ نداده‌اید.",
  aboutColorGray: "خاکستری",
  aboutColorGrayDescription: "دعوت را رد کرده‌اید.",
  aboutCalendarEventDetails: "برای جزئیات و پاسخ روی رویداد کلیک کنید.",
  aboutFriendPageTitle: "صفحه دوستان",
  aboutFriendPageDescription: "نام کاربری را وارد کنید یا پیوند دعوت / کد QR را بفرستید.",
  aboutHomePageTitle: "صفحه اصلی",
  aboutHomePageDescription: "رویدادهای آینده را ببینید و حضور خود را اعلام کنید.",
  aboutRepostScreenTitle: "صفحه بازنشر",
  aboutGoogleCalendarDescription: "با این دکمه رویداد را به تقویم Google بیفزایید.",
  aboutRepostDescription: "پس از تأیید حضور می‌توانید رویداد را برای دوستان بازنشر کنید.",
};

export default fa;